import React from "react";

const NewsArticleDate: React.FC<{
  date: string;
  modified?: string;
}> = ({ date, modified }) => {
  const articleDate = new Date(modified || date).toLocaleDateString("en-US", {
    dateStyle: "long",
  });

  return (
    <span className="text-xs flex flex-wrap">
      <span className="mr-xs" data-testid="article-date">
        {modified ? "Last updated" : "Published on"} {articleDate}
      </span>
    </span>
  );
};

export default NewsArticleDate;
